module.exports = __webpack_public_path__ + "img/idCardDateImg.f81560dc.png";